import * as types from './types'

export default {
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_PROFILE] (state, user) {
    state.user.profile = user
  },
  [types.SET_USER_ROLES] (state, roles) {
    state.user.roles = roles
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/user/mutations.js
// module id = null
// module chunks = 